import Banner from "./components/banner";
import Benefits from "./components/benefits";
import FamilyLaw from "./components/familyLaw";
import Footer from "./components/footer";
import Header from "./components/header";
import HowCanWeHelp from "./components/howCanWeHelp";
import LaborLaw from "./components/laborLaw";
import RealestateLaw from "./components/realestateLaw";

function App() {
  return (
    <>
      <Header />
      <Banner />
      <HowCanWeHelp />
      <FamilyLaw />
      <LaborLaw />
      <RealestateLaw />
      <Benefits />
      <Footer />
    </>
  );
}

export default App;
